@if (title) {
<h2 mat-dialog-title>
  {{ title }}
</h2>
}

<mat-dialog-content>
  <p class="message">{{ message }}</p>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button (click)="onDismiss()">{{ textDismiss }}</button>
</mat-dialog-actions>
